// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Gq5wF","dark":"Footer_dark__tUCOe","light":"Footer_light___lES2","copy":"Footer_copy__G1l3o","links":"Footer_links__y6OjA"};